import { Grid, LinearProgress, Typography } from "@material-ui/core";
import SchoolIcon from "@material-ui/icons/School";
import React, { FC } from "react";
import { useIntl } from "react-intl";
import {
  downloadCandidateCourseCertificate,
  downloadCandidateCoursePerformanceRecord,
} from "../../api/CandidateCourseCertificateApi";
import { useGetCandidateCoursesQuery } from "../../api/rtk/MeApi";
import { GetTranslatedValueIntl } from "../../model/Shared/TranslatedValue";
import { CandidateCourseViewModel, isCertificateAvailable } from "../../model/courses/CandidateCourseViewModel";
import { GetTranslation } from "../../translations/GetTranslation";
import CandidateCourseTable from "../candidateCourses/CandidateCourseTable";
import TranslatedMessage from "../translations/TranslatedMessage";
import HomeSection from "./HomeSection";

const MyCourses: FC = () => {
  const intl = useIntl();

  const { data: myCandidateCourses, isFetching: isMyCandidateCoursesFetching } = useGetCandidateCoursesQuery(undefined);
  const isLoading = isMyCandidateCoursesFetching;

  const handleDownloadCertificate = async (candidateCourse: CandidateCourseViewModel) => {
    if (isCertificateAvailable(candidateCourse)) {
      var certificateFileNamePrefix = GetTranslation(intl, "candidateCourse.certificate.fileNamePrefix");
      var courseName = GetTranslatedValueIntl(intl, candidateCourse.courseName);
      var certificateFileName = `${certificateFileNamePrefix} - ${courseName}`;
      await downloadCandidateCourseCertificate(candidateCourse.id, certificateFileName);
    }
  };

  const handleDownloadPerformanceRecord = async (candidateCourse: CandidateCourseViewModel) => {
    var performanceRecordFileNamePrefix = GetTranslation(intl, "candidateCourse.performanceRecord.fileNamePrefix");
    var courseName = GetTranslatedValueIntl(intl, candidateCourse.courseName);
    var performanceRecordFileName = `${performanceRecordFileNamePrefix} - ${courseName}`;
    await downloadCandidateCoursePerformanceRecord(candidateCourse.id, performanceRecordFileName);
  };

  if (!isLoading && myCandidateCourses === undefined) {
    return null;
  }

  return (
    <HomeSection icon={<SchoolIcon />} title={<TranslatedMessage id="home.myCourses" />}>
      <Grid container spacing={2}>
        {isLoading && (
          <Grid item xs={12}>
            <LinearProgress variant="query" />
          </Grid>
        )}
        {!isLoading && (
          <Grid item xs={12}>
            {myCandidateCourses && myCandidateCourses.length ? (
              <CandidateCourseTable
                candidateCourses={myCandidateCourses}
                handleDownloadCertificate={handleDownloadCertificate}
                handleDownloadPerformanceRecord={handleDownloadPerformanceRecord}
              />
            ) : (
              <Typography>
                <TranslatedMessage id="table.noRecords" />
              </Typography>
            )}
          </Grid>
        )}
      </Grid>
    </HomeSection>
  );
};

export default MyCourses;
